import { Location } from '@angular/common';
import { FileUpload } from './../../service/FileUpload/fileUpload';
import { FileUploadService } from './../../file-upload.service';
import { DetailService } from './../../service/detailService/detail.service';
import { DeliveryService } from './../../service/DeliveryService/delivery.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-content',
  templateUrl: './manage-content.component.html',
  styleUrls: ['./manage-content.component.scss']
})
export class ManageContentComponent implements OnInit {
manageForm:any=[];path:string='DETAILS';currentUpload:any;selectedFile:any;
  constructor(private location: Location, private apiService:DetailService,private UploadService:FileUploadService) {
  
    this.getContent();
   }

  ngOnInit(): void {

  }
  deleteAboutImage(image,a)
  {
    console.log(image)
      this.UploadService.deleteUpload(image,this.path).then((res)=>
      {
        console.log('Previous Image Deleted');
        this.currentUpload=null;
        if(a=='about')
        {
          this.manageForm[0].aboutImage={}
        }
        else if(a=='privacy')
        {
          this.manageForm[0].privacyImage={}
        }
        else if(a=='terms')
        {
          this.manageForm[0].termsImage={}
        }
      })
    
  }
  uploadSingle(event:any,a)
  {
    if(event.target.files && event.target.files[0])
    {
      console.log(a)
      this.selectedFile=event.target.files[0];
    this.currentUpload = new FileUpload(this.selectedFile);
    console.log(this.currentUpload);
    this.UploadService.pushUpload(this.currentUpload,this.path).then((res) => {
      if(a=='about')
      {
        this.manageForm[0].aboutImage=res
      }
      else if(a=='privacy')
      {
        this.manageForm[0].privacyImage=res
      }
      else if(a=='terms')
      {
        this.manageForm[0].termsImage=res
      }
      console.log(res);
      console.log(this.UploadService.uploadPercentage);
      
    });
  }
  }
 
getContent()
{
this.apiService.getDetails().then((res:any)=>
{
  this.manageForm=JSON.parse(JSON.stringify(res));
  console.log(this.manageForm)
})
}
UpdateContent(id,content)
{
  this.apiService.EditDetailsDetail(id,content).then((res)=>
  {
    location.reload();
  })
}
back()
{
  this.location.back();
}
}
